import {useExecutionPolicy} from "@/lib/executionPolicy";
import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg, downloadFile, BACKEND_URL } from "@/lib/api";
import { useLive } from "@/context/LiveContext";
import { StatusBadge } from "@/components/jarvis/StatusBadge";
import { Panel, Action, Note, inputCls } from "./ui";

export default function DiagnosticsTab() {
 const {direct,loading:confirmationsLoading}=useExecutionPolicy();
  const { diag, refreshDiag, commands, refreshCommands } = useLive();
  const [confirm, setConfirm] = useState("");
  const retry = async (id) => { try { await api.post(`/commands/${id}/retry`); toast.success("Reintento enviado"); refreshCommands(); } catch (e) { toast.error(errMsg(e)); } };
  const cancel = async (id) => { await api.post(`/commands/${id}/cancel`); refreshCommands(); };
  const wipe = async () => { try { await api.post("/auth/delete-data", { confirm:direct?"BORRAR":confirm }); toast.success("Datos borrados"); setConfirm(""); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div>
      <Panel title="ESTADO DE CONEXIONES" testId="diagnostics-panel" right={<Action testId="diagnostics-refresh" variant="ghost" onClick={() => { refreshDiag(); refreshCommands(); }}>Actualizar</Action>}>
        <Note>Una variable configurada no equivale a una conexión comprobada. Estados: conectado · desconectado · pendiente · error · desconocido.</Note>
        <div className="mt-3 divide-y divide-cyan-500/10">
          {diag.map((d) => (
            <div key={d.id} className="flex flex-wrap items-center justify-between gap-2 py-2 text-xs" data-testid={`diag-${d.id}`}>
              <span className="text-slate-200 w-48">{d.name}</span><span className="flex-1 text-slate-500 min-w-[200px]">{d.detail}</span><StatusBadge status={d.status} testId={`diag-${d.id}-status`} />
            </div>
          ))}
        </div>
      </Panel>
      <Panel title="HISTORIAL DE ÓRDENES" testId="commands-history">
        <Note>Aceptada (registrada) ≠ informada por el ejecutor ≠ verificada. Las inciertas no se repiten a ciegas.</Note>
        <div className="mt-2 max-h-96 overflow-y-auto divide-y divide-cyan-500/10">
          {commands.map((c) => (
            <div key={c.id} className="py-2 text-xs grid grid-cols-[1fr_auto] gap-2" data-testid={`cmd-row-${c.id}`}>
              <div>
                <span className="text-cyan-200">{c.tool}</span> <span className="text-slate-500">{JSON.stringify(c.args)}</span>
                <div className="text-[10px] text-slate-500">{new Date(c.created_at).toLocaleString("es-UY", { timeZone: "America/Montevideo" })} · {c.source} · fase {c.phase}{c.result?.simulated ? " · SIMULADO" : ""}</div>
                {c.result?.error && <div className="text-[10px] text-red-300">{c.result.error}</div>}
              </div>
              <div className="flex items-center gap-1">
                <StatusBadge status={c.status} />
                {["fallida", "incierta", "vencida"].includes(c.status) && <button className="text-[10px] text-cyan-300 hover:underline" data-testid={`cmd-retry-${c.id}`} onClick={() => retry(c.id)}>reintentar</button>}
                {["pendiente", "reclamada", "ejecutando"].includes(c.status) && <button className="text-[10px] text-red-300 hover:underline" data-testid={`cmd-cancel-${c.id}`} onClick={() => cancel(c.id)}>cancelar</button>}
              </div>
            </div>
          ))}
        </div>
      </Panel>
      <Panel title="DATOS Y ENTREGA" testId="data-panel">
        <div className="flex flex-wrap gap-2">
          <Action testId="export-data-button" variant="ghost" onClick={() => downloadFile("/auth/export", "jarvis_export.json")}>Exportar mis datos</Action>
          <Action testId="download-full-zip" variant="ghost" onClick={() => downloadFile("/downloads/full", "jarvis_full.zip")}>Generar ZIP del proyecto</Action>
          <a href={`${BACKEND_URL}/api/public/downloads`} target="_blank" rel="noreferrer" data-testid="direct-downloads-link" className="px-3 py-2 text-xs uppercase tracking-[0.15em] border border-cyan-500/40 text-cyan-200">Descargas directas</a>
        </div>
        <div className="mt-4 flex flex-wrap gap-2 items-center">
          {!direct&&<input className={`${inputCls} max-w-[200px]`} placeholder='Escriba "BORRAR"' value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="delete-data-input" />}
          <Action testId="delete-data-button" variant="danger" onClick={wipe} disabled={confirmationsLoading||(!direct&&confirm !== "BORRAR")}>Borrar todos mis datos</Action>
        </div>
      </Panel>
    </div>
  );
}
